import { useState, lazy, Suspense } from 'react';
import { Card, List, Divider } from '@mui/material';
import HeaderGestorConfigs from '../../utils/headerGestorConfigs';
import DocumentViewer from './documentViewer';
import DocumentItem from '../../utils/documentItem';

const PreviewAnexos = lazy(() => import('../../utils/PreviewAnexos'));

export default function DocumentosAnexados({ docs, estabelecimento }) {
  const [editDoc, setEditDoc] = useState(null);
  const [previewFiles, setPreviewFiles] = useState([]);
  const [currentFileIndex, setCurrentFileIndex] = useState(0);
  const [previewOpen, setPreviewOpen] = useState(false);

  const DOCUMENTS_CONFIG = [
    { key: 'requerimentoARMED', label: 'Requerimento dirigido a Armed' },
    { key: 'escrituraCS', label: 'Escritura de constituição de Sociedade' },
    { key: 'termoRDT', label: 'Termo de Responsabilidade do Director Técnico' },
    { key: 'copiaDI', label: 'Cópia colorida do documento de identificação' },
    { key: 'croquis', label: 'Planta com quota das instalações e croquis' },
    { key: 'certificadoND', label: 'Certificado de não devedor (AGT)' },
    { key: 'comprovativoPE', label: 'Comprovativo de pagamento de emolumentos' },
    {
      key: 'autorizacaoVencida',
      label: 'Autorização de Exercício vencida',
      condition: estabelecimento?.tipoEntrada === 'Renovação'
    }
  ];

  const visibleDocs = DOCUMENTS_CONFIG.filter(
    d => d.condition !== false
  );

  const allDocuments = visibleDocs
    .map(d => docs?.[d.key])
    .filter(Boolean);

  const handlePreview = (file) => {
    setPreviewFiles(allDocuments);
    setCurrentFileIndex(allDocuments.indexOf(file));
    setPreviewOpen(true);
  };

  return (
    <>
      <Card sx={{ p: 2, mb: 2 }}>
        <HeaderGestorConfigs
          configArea="documentos"
          title="DOCUMENTOS ANEXADOS"
        />


        {docs && <DocumentViewer pdfUrls={docs} />}

        {/* Lista */}
        <List>
          {DOCUMENTS_CONFIG.map(({ key, label, condition = true }, index) => {
            if (!condition) return null;

            return (
              <div key={key}>
                <DocumentItem
                  label={label}
                  file={docs?.[key]}
                  docKey={key}
                  estabelecimentoId={estabelecimento?._id}
                  isEditing={editDoc === key}
                  onToggleEdit={() =>
                    setEditDoc(editDoc === key ? null : key)
                  }
                  onPreview={handlePreview}
                />
                {index < visibleDocs.length - 1 && <Divider />}
              </div>
            );
          })}
        </List>
      </Card>

      {/*  Preview Lazy */}
      <Suspense fallback={<p>A carregar preview...</p>}>
        {previewOpen && (
          <PreviewAnexos
            files={previewFiles}
            currentIndex={currentFileIndex}
            isOpen={previewOpen}
            onClose={() => setPreviewOpen(false)}
            onNavigate={setCurrentFileIndex}
          />
        )}
      </Suspense>
    </>
  );
}
